import React, {useState} from "react";
import {Button} from "antd";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {articlesService} from "../../../../../services/articles/articles.service";

interface ArticleSimple {
    id: number;
    inWishList: boolean;
}

interface AddToWishlistActionProps {
    article: ArticleSimple;
}

export const AddToWishlistAction: React.FC<AddToWishlistActionProps> = ({article}) => {

    const [inWishlist, setInWishlist] = useState<boolean>(article.inWishList);
    const [disabled, setDisabled] = useState<boolean>(false);

    const onClick = async () => {
        setDisabled(true);
        setInWishlist(v => !v)
        try {
            if (inWishlist) {
                await articlesService.removeFromWishList(article.id);
            } else {
                await articlesService.addToWishList(article.id);
            }
        } catch (e) {
            setInWishlist(v => !v)
        } finally {
            setDisabled(false);
        }
    }

    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            className={"article_cart-btn" + (inWishlist ? " in-cart" : "")}
            icon={<FontAwesomeIcon icon={["fas", "star"]}/>}
        >
        </Button>
    )
}